import { gql } from "graphql-request";

export const user = {
  currentUser: gql`
    query CurrentUser($roleScope: String) {
      currentUser(roleScope: $roleScope) {
        id
        firstName
        lastName
        email
        status
        title
        org
        createdDate
        roles {
          roleId
          userId
          projects
        }
        preferences {
          timezone
          timezoneOffset
          isExternalIdpUser
          emailGroups {
            dailyDigest
            projectAccessAndInvitations
            contentAndQuestions
            taskManagement
            milestones
          }
        }
        organization {
          id
          name
          shortName
          tenantId
          type
          country
        }
        permissions {
          canAccessCCS
          canAccessUserManagement
          canAccessApp
          canAccessAdminPages
          canCreateOrganizationalAdminAccounts
          canDeactivateOrganizationalAdminAccounts
          canReactivateOrganizationalAdminAccounts
          canViewAllContent
          canAssignSelfAsPM
          canAssignUsersToProjectAtProjectCreation
          canCreateNewProject
          canViewAllProjectsForOrganization
          canDeleteAnyProjectsForOrganization
          canCreateUserAccounts
          canBulkCreateUserAccounts
          canAssignUserTypeAccountToAUser
          canEditOwnAccountProfile
          canEditOtherAccountProperties
          canInactivateUserAccounts
          canInactivateExternalUserAccounts
          canReactivateUserAccounts
          canReactivateExternalUserAccounts
          canSelectOrganizationAtUserCreation
          canConfigureExternalUserActivatedAccountNotifications
          canResendActivationEmail
        }
      }
    }
  `,
  user: gql`
    query User($userId: String!, $roleScope: String) {
      user(userId: $userId, roleScope: $roleScope) {
        id
        firstName
        lastName
        email
        status
        title
        org
        createdDate
        roles {
          roleId
          userId
          projects
        }
        preferences {
          timezone
          timezoneOffset
          isExternalIdpUser
          emailGroups {
            dailyDigest
            projectAccessAndInvitations
            contentAndQuestions
            taskManagement
            milestones
          }
        }
        organization {
          id
          name
          shortName
          tenantId
          type
          country
          parentId
          dunsNumber
          ebsClientId
          evCode
          externalId
          globalId
          masterFileType
        }
      }
    }
  `,
  legalAcknowledgements: gql`
    query LegalAcknowledgement {
      legalAcknowledgements {
        id
        title
        body
      }
    }
  `,
};
